import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';

let supabaseClient: SupabaseClient<Database> | null = null;

export function getSupabaseClient(): SupabaseClient<Database> {
  if (supabaseClient) {
    return supabaseClient;
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error(
      'Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'
    );
  }

  supabaseClient = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });

  return supabaseClient;
}

/**
 * @deprecated Liefert seit dem Ausbau des Service-Role-Keys denselben Client
 * wie {@link getSupabaseClient}. Neue Aufrufstellen sollen direkt
 * `getSupabaseClient()` verwenden; die bestehenden Aufrufe im Admin-Panel
 * werden in einem eigenen Schritt umgestellt.
 *
 * Hintergrund: Die Funktion erzeugte bis dahin einen Client mit
 * `VITE_SUPABASE_SERVICE_ROLE_KEY`. Weil Vite alle `VITE_*`-Variablen in das
 * Bundle inlined, lag der Service-Role-Key im Browser von admin.parentpath.de
 * aus - jeder Besucher der Seite konnte ihn auslesen und damit unter Umgehung
 * jeder RLS auf die gesamte Datenbank zugreifen.
 *
 * Der Zugriff des Admin-Panels laeuft jetzt ueber den anon key plus das JWT
 * des eingeloggten Admins; die Rechte kommen aus den `is_admin()`-Policies
 * (043, 162, 163). Die beiden Operationen, die echte Superrechte brauchen
 * (`auth.admin.createUser` / `auth.admin.deleteUser`), liegen in der Edge
 * Function `admin-users`.
 */
export function getSupabaseAdminClient(): SupabaseClient<Database> {
  return getSupabaseClient();
}

export { createClient };
export type { SupabaseClient };
export type { Database } from './types';
export * from './types';
export * from './content';
